<template>
	<div v-loading="loading" element-loading-text="视频加载中..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- <div class="tops">
			<div>欢迎进入甘肃建投专业人员继续教育平台</div>
		</div> -->

		<div class="Tips" id="Tips" v-if="Tips">
			<div><i class="el-icon-warning layui-icon-tips"></i> </div>
			<div>{{configs.video_tip}}</div>
			<!-- <div><i class="el-icon-close" @click="Tips=false"></i></div> -->
		</div>
		<div class="content">

			<div class="left">
				<!-- <div class="tit">{{coursedata.eduCourse.title}}</div> -->
				<div class="catalogue"><span>课程目录</span></div>
				<div class="list">
					<div class="item" v-for="(item,index) in courslist" :key="index" ref="listItem">
						<div v-if="item.userDuration.hasOwnProperty('status') && item.userDuration.status==2"
							style="color:#E3B00F ;">{{item.title}}</div>
						<div v-else>{{item.title}}</div>
						<div class="being"
							v-if="item.userDuration.hasOwnProperty('status') && item.userDuration.status==2"><i
								class="el-icon-video-play"></i>正在学习该课程
						</div>
						<div v-if="item.userDuration.hasOwnProperty('status') && item.userDuration.status==3">已完成</div>
						<div v-if="!item.userDuration.hasOwnProperty('status')" class="nostudy">未学习</div>
					</div>
				</div>
			</div>
			<div class="right" @contextmenu.prevent="disableRightClick">
				<div class="rig-tit">
					<div>{{it.titles}}</div>
					<div>总学时：{{coursedata.siteCredits}}学时&emsp;您已学习：{{coursedata.credits}}学时</div>
					<div @click="back()"><i class="el-icon-switch-button"></i>离开学习</div>
				</div>
				<div class="rig-video">
					<!-- <video width="100%" height="760"  controlslist="nodownload noremoteplayback noplaybackrate"
						controls @pause='Pause()'>
					</video> -->
					<video v-if="!loadings" ref="videoPlay" width="100%" height="100%" :src="coursedata.video_url"
						id="myvideo" controls controlslist="nodownload noremoteplayback noplaybackrate" @ended='ended()'
						autoplay @canplay="getvidur" @loadedmetadata="videoLoaded">

					</video>
					<div v-if="loadings"
						style="width: 100%;height: 100%;text-align: center;background: #000;color: #fff;padding-top: 350px;">
						<div>当前网络不稳定，无法获取视频信息</div>
						<div style="width: 120px;margin: 0 auto;">
							<div style="float: left;">你可以</div>
							<div style="float: left;color: #E3B00F;cursor: pointer;" @click="reds">刷新</div> 试试
						</div>
					</div>
				</div>
			</div>
			<popus ref="pop" :xIshow="false">
				<!-- <img src="@/assets/esc.svg" /> -->
				<div class="tit">{{ callEnd ? "已重置" : "正在点名中" }}</div>
				<div class="txt">
					{{
			  callEnd
			    ? "由于你未参加点名，本课时需重新学习"
			    : reciprocal + "秒内学员未作出 任何回应，本课时需重新学习"
			}}
				</div>
				<div class="pop_bot">
					<div class="bot botcss" @click="detect" v-if="!callEnd">点名检测</div>
					<div class="bot botcss" v-else>知道了</div>
				</div>
			</popus>
			<!-- 人脸验证 -->
			<popus ref="pop3" :xIshow="false">
				<!-- <img src="@/assets/images/faceicon.svg" v-show="!callEnd" /> -->
				<div class="txt">
					尊敬的学员，根据公司规定我们会在您学习过程中进行人脸验证，为保证您的隐私，请您在摄像头视野内确保衣冠整齐。
				</div>
				<br />
				<div class="pop_bot">
					<div class="bot botcss" @click="facepop">同意并继续</div>
				</div>
			</popus>
			<faceId ref="face" :is_face="coursedata.is_check_face" :conts='coursedata' @faceEnd="faceNumadd" />
		</div>
	</div>
</template>

<script>
	import popus from "@/components/popus.vue";
	import FaceId from "@/components/face.vue";
	import Hls from "hls.js";
	const video = () => {
		const videotime = document.getElementById('myvideo')
		//console.log(videotime.duration)
	}
	export default {
		components: {
			FaceId,
			popus
		},
		data() {
			return {
				loading: false,
				coursedata: {
					video_url: '',
					is_check_face: '',
					siteCredits: ''
				},
				cdnurl: this.$cdn,
				courslist: [],
				Tips: true,
				singlePlayer: '',
				it: {},
				//是否播放完成
				flag: 1,
				configs: [],
				facechecktims: [],
				syy: '',
				reciprocal: 60, //倒计时
				callEnd: false,
				nums: 0,
				//进来时间
				timestampInSeconds: '',
				ess: 0,
				currentTime: 0,
				loadings: false,
				isFullLoaded: false
			};
		},
		created() {

		},
		mounted() {
			this.configs = JSON.parse(sessionStorage.getItem('configs'))
			this.it = this.$route.query
			this.getcourse()
		},
		methods: {
			//禁止鼠标
			disableRightClick(event) {
				event.preventDefault();
			},
			getvidur() {
				video()
			},
			reds() {
				window.location.reload()
			},
			handleError() {
				this.loadings = true
				console.error("视频加载失败");
			},
			facepop() {
				this.$refs.pop3.close();
				this.$refs.face.open();
			},
			//获取课程详情
			async getcourse() {
				const res = await this.$http({
						method: 'GET',
						url: '/edu/durationdetailnew?course_id=' + this.it.course_id + '&directory_id=' + this.it
							.directory_id + '&duration_id=' + this.it.duration_id + '&type=1',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						}
					})
					.then(response => {
						return response

					})
					.catch(error => {
						console.log(error)
					})
				if (res.code == 1) {
					this.coursedata = res.data
					if (this.coursedata.video_url.indexOf('http') === -1) {
						this.coursedata.video_url = this.cdnurl + this.coursedata.video_url;
					} else {
						this.coursedata.video_url = this.coursedata.video_url;
					}
					this.courslist = res.data.eduDuration.data
					this.courslist.forEach(res => {
						res.userDuration = {};
						if (this.coursedata.userDuration.hasOwnProperty(res.id)) {
							res.userDuration = this.coursedata.userDuration[res.id];
						}
					})
					//判断视频是否为视频流
					const videoUrl = res.data.video_url
					let urlArr = videoUrl.split('.');
					if (urlArr[urlArr.length - 1] === 'm3u8') {
						this.$nextTick(() => {
							const video = this.$refs.videoPlay;
							const hls = new Hls();
							hls.loadSource(videoUrl);
							hls.attachMedia(video);
						});
					}
					const video = document.createElement('video');

					video.addEventListener('loadedmetadata', this.getVideoDuration);
					const timestampInMilliseconds = Date.now();
					this.timestampInSeconds = Math.floor(timestampInMilliseconds /
						1000); // 输出当前时间的时间戳，单位为秒
					//赋值播放时长
					this.$refs.videoPlay.currentTime = this.coursedata.yduration

					let _this = this;
					let yduration = _this.coursedata.yduration
					this.$refs.videoPlay.addEventListener("timeupdate", function(e) {

						let myVideos = _this.$refs.videoPlay;
						let elapsedTime = myVideos.currentTime - yduration
						// 如果已经过了2分钟（120秒），执行保存操作
						if (elapsedTime >= _this.coursedata.eduCourse.videotime * 60) {
							yduration = myVideos.currentTime
							_this.timeSave(1)
						}

					})
					this.$refs.videoPlay.addEventListener('error', function(event) {

						_this.loadings = true

						console.error('An error occurred:', event);


					});

					for (let s = 0; s < this.courslist.length; s++) {
						if (this.it.duration_id == this.courslist[s].userDuration
							.edu_duration_id) {
							this.syy = s
							this.$nextTick(() => {
								const targetItem = this.$refs.listItem[this.syy];
								if (targetItem) {
									targetItem.scrollIntoView();
								}
							});
						}
					}

					// console.log(this.loadings)
					this.$refs.videoPlay.onloadedmetadata = () => {
						let _this = this;
						this.$refs.videoPlay.addEventListener("timeupdate", function(e) {
							let myVideo = _this.$refs.videoPlay;
							//let nowtime = _this.$refs.videoPlay.currentTime;
							//console.log(nowtime)
							//点名
							if (_this.coursedata.faceConfig.is_call === 1) {
								for (let x = 0; x < _this.courslist.length; x++) {
									if (_this.it.duration_id == _this.courslist[x].userDuration
										.edu_duration_id) {

										if (myVideo.currentTime > _this.coursedata.faceConfig
											.call_time *
											60 - 1 && _this.courslist[x].userDuration
											.is_call == -1
										) {
											_this.pause()
											// _this.isc = true;
											//点名回应时间
											_this.rollCall();
										}
									}
								}

							}
							//人脸验证
							if (_this.coursedata.faceConfig.is_openface === 1) {
								for (let x = 0; x < _this.courslist.length; x++) {
									if (_this.it.duration_id == _this.courslist[x].userDuration
										.edu_duration_id) {

										if (_this.courslist[x].userDuration.timerange != '') {
											_this.nums = _this.courslist[x].userDuration
												.num
											_this.facechecktims = _this.courslist[x]
												.userDuration
												.timerange
												.split(',')
											break;
										}
									}
								}
								const facetimw = _this.facechecktims.map(function(value) {
									return parseInt(value) * 60
								})
								let facearr = []
								facetimw.forEach(function(item, index) {
									let is_face = false
									if (_this.nums !== 0 && (index + 1) <= _this
										.nums) {
										is_face = true
									}
									facearr.push({
										faceTime: item,
										is_face
									})
								})
								facearr.forEach(function(item) {
									if (myVideo.currentTime >= item.faceTime &&
										item.is_face === false) {
										_this.pause()
										_this.$refs.pop3.open();
									}
								})
							}
						})
					}

				} else if (res.code == 3) {
					this.$confirm(res.msg, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: false,
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: "/course",
						})
					}).catch(() => {
						this.$router.push({
							path: "/course",
						})
					});
				} else {
					this.$confirm(res.msg, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: false,
						type: 'warning'
					}).then(() => {
						this.it.duration_id = res.data
						this.getcourse()
					}).catch(() => {
						this.it.duration_id = res.data
						this.getcourse()
					});
					//this.$message(response.msg);

				}
				this.loading = false

			},
			getVideoDuration(event) {

				const video = event.target;
				const videoDuration = video.duration;
				//console.log(videoDuration)
			},
			//点名
			rollCall() {
				//console.log("进入点名");
				this.$refs.pop.open();
				const unNum = setInterval(() => {
					if (this.reciprocal <= 0) {
						clearInterval(unNum);
					} else {
						this.reciprocal--;
						//console.log(this.reciprocal);
					}
				}, 1000);

			},
			detect() {
				this.$http({
						method: 'POST',
						url: '/Face/call',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
						data: {
							edu_course_id: this.it.course_id,
							edu_directory_id: this.it.directory_id,
							edu_duration_id: this.it.duration_id,
						}
					})
					.then(response => {
						if (response.code == 1) {
							this.$message({
								message: "点名成功",
								type: "success",
							});
							this.timeSave(1)
							this.getcourse()
							this.$refs.videoPlay.play();
							this.$refs.pop.close();
						}
					})
			},
			//人脸回调
			//第一次人脸完成回调
			faceNumadd() {
				this.$refs.videoPlay.play();
				this.$refs.videoPlay.currentTime += 3
				//console.log(this.$refs.videoPlay.currentTime)
				this.timeSave(1)
				this.getcourse()
			},

			back() {
				this.$refs.videoPlay.pause();
				this.ess = 1
				this.timeSave(1)

				let that = this
				setTimeout(() => {
					// that.$router.go(-1);
					that.$router.push({
						path: "/courses",
					})
				}, 200);
			},
			//视频加载完成
			videoLoaded(event) {
				// 当视频加载完成时，这个方法会被调用
				console.log('视频加载完成', event);
				console.log(this.$refs.videoPlay.duration)
			},
			//暂停播放
			pause() {
				this.$refs.videoPlay.pause();
			},
			//暂停保存时长
			// //ended
			ended() {
				this.timeSave(2)
			},
			//跳转下一节
			next() {
				this.flag == 1
				this.getcourselist()
			},
			async getcourselist() {
				const res = await this.$http({
						method: 'GET',
						url: '/edu/course_list?course_id=' + this.it.course_id + '&directory_id=' +
							this.it
							.directory_id,
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						}
					})
					.then(response => {
						return response

					})
					.catch(error => {
						console.log(error)
					})
				let that = this
				if (res.code == 1) {
					let durations = res.data.course_list.eduDirectory.durations
					durations.some((item, index) => {
						// console.log(item)
						if (item.progress < 100) {
							// console.log(item)
							let ids = item.id
							that.it.duration_id = item.id
							that.it.titles = item.title
							that.$router.push({
								path: "/video",
								query: {
									course_id: that.it.course_id,
									directory_id: that.it.directory_id,
									duration_id: ids
								}
							})
							that.getcourse()
							return true
						}
					})
				} else {
					this.$message(res.msg);
				}
			},
			async Savetime(flag) {
				let last_element = this.courslist[this.courslist.length - 1]
				const res = await this.$http({
						method: 'POST',
						url: '/edu/savedurationinfo',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
						data: {
							course_id: this.it.course_id,
							duration_id: this.it.duration_id,
							flag: flag,
							current_time: this.currentTime
						}
					}).then(response => {
						return response
					})
					.catch(error => {
						console.log(error)
					})
				if (res.code === 1) {
					if (flag === 2) {
						//console.log(last_element.id, this.it)
						//最后一课的id相等的时候直接跳出考试
						if (last_element.id === this.it.duration_id) {
							this.$confirm("已完成所有课时学习，请到首页进行考试！", '提示', {
								confirmButtonText: '确定',
								showClose: false,
								type: 'warning'
							}).then(() => {
								this.$router.push({
									path: "/course",
								})
							}).catch(() => {

							});
						} else {
							this.$confirm('"已完成当前课时学习" : "是否播放下一课时"', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								showClose: false,
								type: 'warning'
							}).then(() => {
								this.currentTime = 0
								this.loading = true
								setTimeout(() => {
									this.next()
								}, 1500);
							}).catch(() => {
								this.$router.push({
									path: "/course",
								})
							});
						}
					}
				} else if (res.code === 3) {
					this.$confirm("已完成所有课时学习，请到首页进行考试！", '提示', {
						confirmButtonText: '确定',
						showClose: false,
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: "/course",
						})
					}).catch(() => {

					});
				} else if (res.code === -3) {
					this.$confirm("当前课程已结束，暂时无法学习！", '提示', {
						confirmButtonText: '确定',
						showClose: false,
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: "/course",
						})
					}).catch(() => {

					});
				} else {
					this.$message(res.msg);
				}
			},
			//保存时长
			timeSave(flag) {
				const timestampInMilliseconds = Date.now();
				const timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
				const tines = timestampInSeconds - this.timestampInSeconds
				const ts = this.$refs.videoPlay.currentTime - this.coursedata.yduration
				this.currentTime = this.$refs.videoPlay.currentTime
				// console.log(ts)
				// console.log('进入时间' + tines)
				if (ts <= tines + 5 && ts > 0) {
					this.Savetime(flag)

				} else {
					// this.flag = 1
					this.$message({
						message: '系统判定:请勿拖拽学习或倍速学习,视频将在3s后重新加载！',
						type: 'warning'
					});
					if (this.ess === 0) {
						setTimeout(() => {
							window.location.reload()
						}, 3000);
					}
				}
			}
		},
	}
</script>
<style>
	body {
		overflow-y: auto !important;
	}
</style>
<style scoped>
	.tops {
		width: 1890px;
		height: 43px;
		line-height: 43px;
		background: #E9E9E9;
	}

	.tops div {
		margin-left: 150px;
	}

	.Tips {
		width: 1890px;
		height: 53px;
		line-height: 53px;
		background: #FFF1F0;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #FFCCC7;
	}

	.Tips div:nth-child(1) {
		color: #F40000;
		margin-left: 25px;
		float: left;
	}

	.Tips div:nth-child(3) {
		margin-right: 25px;
		float: right;
	}

	.nostudy {
		color: #636363 !important;
	}

	.Tips div:nth-child(2) {
		float: left;
		width: 1400px;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		margin-left: 15px;
		color: rgba(0, 0, 0, 0.88);
	}

	.content {
		width: 1910px;
		height: 92vh;
		background-image: url('../../assets/videobj.jpg');
	}

	.content .left {
		float: left;
		width: 25%;
		height: 847px;
		margin-left: 0.5%;
		margin-top: 0.5%;
		background: #FFFFFF;
	}

	.content .left .tit {
		width: 96%;
		padding-top: 20px;
		min-height: 85px;
		line-height: 34px;
		background: #FFFFFF;
		font-size: 20px;
		padding-left: 20px;
		font-weight: bold;
		color: #0762B3;
	}

	.content .left .catalogue {
		width: 100%;
		height: 74px;
		line-height: 74px;
		background: #0762B3;
	}

	.content .left .catalogue span {
		font-size: 22px;
		font-weight: bold;
		padding-left: 51px;
		color: #FFFFFF;
	}

	.content .left .list {
		width: 100%;
		height: 90%;
		margin-top: 10px;
		overflow-y: scroll;
	}

	/*滚动条样式*/

	.content .left .list::-webkit-scrollbar {
		/*滚动条整体样式*/

		width: 2px;
		/*高宽分别对应横竖滚动条的尺寸*/

		height: 4px;

	}

	.content .left .list::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/

		border-radius: 5px;

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		background: rgba(0, 0, 0, 0.2);

	}

	.content .left .list::-webkit-scrollbar-track {
		/*滚动条里面轨道*/

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		border-radius: 0;

		background: rgba(0, 0, 0, 0.1);

	}

	.content .left .list .item {
		min-height: 20px;
		line-height: 20px;
		width: 95%;
		margin: 20px auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content .left .list .item div:nth-child(1) {
		min-height: 33px;
		width: 66%;
		float: left;
	}

	.content .left .list .item .being .el-icon-video-play {
		margin-right: 6px;
	}

	.content .left .list .item .being {
		width: 142px !important;
		height: 34px;
		background: #E3B00F;
		color: #fff !important;
		border-radius: 17px;
		font-size: 14px;
		line-height: 34px;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center !important;
	}

	.content .left .list .item div:nth-child(2) {
		min-height: 33px;
		width: 27%;
		float: right;
		color: #0BAE25;
		text-align: right;
	}

	.content .right {
		float: right;
		width: 73.4%;
		height: 97.5%;
		margin-right: 0.5%;
		margin-top: 0.5%;
		background: #FFFFFF;
	}

	.content .right .rig-tit {
		height: 68px;
		line-height: 68px;
	}

	.content .right .rig-tit div:nth-child(1) {
		min-width: 120px;
		font-size: 20px;
		font-weight: 400;
		color: #131212;
		float: left;
		margin-left: 31px;
	}

	.el-icon-switch-button {
		margin-right: 5px;
	}

	.content .right .rig-tit div:nth-child(2) {
		font-size: 16px;
		font-weight: 400;
		float: left;
		color: #000000;
		margin-left: 150px;
	}

	.content .right .rig-tit div:nth-child(3) {
		font-size: 16px;
		font-weight: 400;
		float: right;
		color: #0762B3;
		margin-right: 20px;
		cursor: pointer;
	}

	.content .right .rig-video {
		width: 98%;
		margin: 0 auto;
		height: 760px;
		background: #000000;
	}

	video {
		border: 0;
		object-fit: fill;
	}

	video::-webkit-media-controls-fullscreen-button {
		display: none !important;
	}

	video:focus {
		outline: -webkit-focus-ring-color auto 0px;
	}

	video::-webkit-media-controls-timeline {
		display: none;
	}

	video::-webkit-media-controls-volume-slider {
		display: none;
	}
</style>